<script setup lang="ts">
// AuthLayout - Simple centered layout for authentication pages
// No sidebar, centered content container
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
</script>

<template>
  <div class="auth-layout">
    <div class="auth-container">
      <div class="auth-logo">
        <span class="logo-text">ProfitJam</span>
      </div>

      <div class="auth-content">
        <slot />
      </div>

      <div class="auth-footer">
        <p class="auth-copyright">{{ t('layout.copyright', { year: new Date().getFullYear() }) }}</p>
      </div>
    </div>
  </div>
</template>

<style scoped>
.auth-layout {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--color-background-secondary, #F9F9F9);
  padding: 24px;
}

.auth-container {
  width: 100%;
  max-width: 400px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 32px;
}

.auth-logo {
  display: flex;
  align-items: center;
  justify-content: center;
}

.logo-text {
  font-family: var(--font-family-heading, 'Instrument Sans', sans-serif);
  font-size: 24px;
  font-weight: 700;
  color: var(--color-primary, #021E30);
}

.auth-content {
  width: 100%;
  background-color: var(--color-white, #FFFFFF);
  border-radius: var(--radius-xl, 12px);
  padding: 32px;
  box-shadow: var(--shadow-lg, 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -4px rgba(0, 0, 0, 0.1));
}

.auth-footer {
  text-align: center;
}

.auth-copyright {
  font-size: var(--font-size-sm, 12px);
  color: var(--color-text-secondary, rgba(0, 0, 0, 0.45));
  margin: 0;
}

/* Responsive adjustments */
@media (max-width: 480px) {
  .auth-layout {
    padding: 16px;
  }

  .auth-container {
    gap: 24px;
  }

  .auth-content {
    padding: 24px;
  }
}
</style>
